var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11488 3311)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11486.667 -3309.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1071.142,655.121h-11.151a3.067,3.067,0,0,1-3.091-3.036V640.824a3.067,3.067,0,0,1,3.091-3.036h11.151a3.067,3.067,0,0,1,3.091,3.036v11.261A3.067,3.067,0,0,1,1071.142,655.121Zm-13.249-8.363v5.328a2.075,2.075,0,0,0,2.1,2.046h11.151a2.075,2.075,0,0,0,2.1-2.046V640.824a2.075,2.075,0,0,0-2.1-2.046h-11.151a2.075,2.075,0,0,0-2.1,2.046Z",
    transform: "translate(-1056.9 -637.788)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.932 5.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.99,
    height: 7.114,
    rx: 0.995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.482 2.511)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.99,
    height: 4.603,
    rx: 0.995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.964 4.436)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.99,
    height: 2.679,
    rx: 0.995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.446 0.741)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.99,
    height: 6.374,
    rx: 0.995
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.928 5.586)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.99,
    height: 1.528,
    rx: 0.764
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/Poll.607c64e951d5bd56f0d2cf21e1769634.svg";
export { ForwardRef as ReactComponent };